/* tslint:disable */
/* eslint-disable */
/**
 * Bfree API
 * API Documentation for B&Free Project
 *
 * The version of the OpenAPI document: 0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    Country,
    CountryFromJSON,
    CountryToJSON,
} from '../models';

export interface ApiCountriesIdGetRequest {
    id: string;
}

/**
 * 
 */
export class CountriesApi extends runtime.BaseAPI {

    /**
     */
    async apiCountriesGetRaw(initOverrides?: RequestInit): Promise<runtime.ApiResponse<Array<Country>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("passport", []);
        }

        const response = await this.request({
            path: `/api/countries`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(CountryFromJSON));
    }

    /**
     */
    async apiCountriesGet(initOverrides?: RequestInit): Promise<Array<Country>> {
        const response = await this.apiCountriesGetRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async apiCountriesIdGetRaw(requestParameters: ApiCountriesIdGetRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<Country>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling apiCountriesIdGet.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("passport", []);
        }

        const response = await this.request({
            path: `/api/countries/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CountryFromJSON(jsonValue));
    }

    /**
     */
    async apiCountriesIdGet(requestParameters: ApiCountriesIdGetRequest, initOverrides?: RequestInit): Promise<Country> {
        const response = await this.apiCountriesIdGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
